module.exports = __webpack_public_path__ + "img/appstore.89631b88.png";